import { Environment } from "./Environment";
import { Collection } from "../utils/Collection";
import { SelectInput } from "../utils/ui/SelectInput";

export interface IEnvironmentObject
{
	position: number[];
}

export class EnvironmentSelector extends SelectInput<Environment>
{
	constructor(environments: Collection<Environment>)
	{
		super({
			element: <HTMLSelectElement>document.getElementById("scene"),
			values:  environments,
			selectedIndex: 0
		});
	}
}